(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
                let event = new Event("recommendations-loaded", {bubbles: true});
                document.body.dispatchEvent(event);
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            
            const slideWidth = document.querySelector('#you-may-also-like swiper-slide').style.width;

            document.querySelectorAll('#you-may-also-like swiper-slide').forEach(slide => {
              slide.style.width = slideWidth;
            });


          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();
})();
